var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.71 3.795a1 1 0 0 0-1.415 0L8 10.27 1.705 3.795a1 1 0 0 0-1.41 0 1 1 0 0 0 0 1.43l6.645 6.83a1.5 1.5 0 0 0 2.12 0l6.65-6.83a1 1 0 0 0 0-1.43"
  })));
};
export default SvgChevronDown;